import { useOrganizationDomain } from '~/composables/use-organization-domain';

export const organizationAccess = defineNuxtRouteMiddleware((to) => {
  const organizationDomain = useOrganizationDomain();

  if (organizationDomain && to.path.startsWith('/org/')) {
    throw new Error('Access denied');
  }
});
